<template>
  <transition name="slide-fade">
    <div style="text-align:center;">
      <img style="width:90%;" src="@/assets/img/success.png" alt="">
      <div style="color:#999;">该事项已审批</div>
      <div style="color:#999;margin-top:10px;">请登录有花果系统查看详情</div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  created() {

  },
  methods: {
    
  }
}
</script>
<style>
.slide-fade{
 position: absolute;left:0;right: 0;
}
.slide-fade-enter-active {
 transition: all 1.2s ease;
}
.slide-fade-leave-active {
 
 transition: all .1s cubic-bezier(2.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
{
 left:0;right: 0;
 transform: translateY(-500px);
 opacity: 0;
}
</style>